import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";

interface TabDef {
  readonly to: string;
  readonly labelKey: string;
  readonly testId: string;
}

const TABS: readonly TabDef[] = [
  {
    to: "/communications",
    labelKey: "communications.tabs.catalog",
    testId: "communications-tab-catalog",
  },
  {
    to: "/communications/locales",
    labelKey: "communications.tabs.locales",
    testId: "communications-tab-locales",
  },
];

export function CommunicationsTabs() {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t("communications.tabs.ariaLabel")}
      className="flex flex-wrap gap-1 border-b border-border"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          data-testid={tab.testId}
          className={({ isActive }) =>
            cn(
              "-mb-px border-b-2 px-3 py-2 text-sm font-medium",
              isActive
                ? "border-wander-orange text-wander-orange"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )
          }
        >
          {t(tab.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
}
